import fs from 'fs';
import path from 'path';
import {
  Locale,
  LocaleInfo,
  TranslationResourceProviderBase,
  TranslationResource,
} from '@rbx/intl';

export default class TranslationResourceProvider extends TranslationResourceProviderBase {
  constructor(public defaultLocaleInfo: LocaleInfo) {
    super(defaultLocaleInfo);
  }

  async loadRuntimeLocaleInfo(): Promise<LocaleInfo> {
    return this.defaultLocaleInfo;
  }

  // eslint-disable-next-line class-methods-use-this -- (@zwang, 08/07/24): concrete implementation for fetching translation resources
  protected async fetchTranslationResource(
    namespace: string,
    locale: Locale,
  ): Promise<TranslationResource> {
    const filePath = path.join(process.cwd(), 'public', 'locales', locale, `${namespace}.json`);

    try {
      const data = await fs.promises.readFile(filePath, 'utf8');
      const translationResource = JSON.parse(data) as TranslationResource;
      return translationResource;
    } catch (err) {
      if (err instanceof SyntaxError) {
        throw new Error(`Failed to parse translation file at ${filePath}: ${err.message}`);
      } else if ((err as NodeJS.ErrnoException).code === 'ENOENT') {
        throw new Error(`Translation file not found at ${filePath}`);
      } else {
        const error = err as Error;
        throw new Error(`Failed to read translation file at ${filePath}: ${error.message}`);
      }
    }
  }
}
